/** localStorage can throw (private windows, blocked site data); callers must work without it. */
export function readStored<T>(key: string): T | null {
    try {
        const raw = localStorage.getItem(key);

        return raw ? JSON.parse(raw) as T : null;
    } catch {
        return null;
    }
}

export function writeStored(key: string, value: unknown): void {
    try {
        localStorage.setItem(key, JSON.stringify(value));
    } catch {
        // Not persisting just means the prompt may repeat
    }
}

export function removeStored(prefix: string): void {
    try {
        Object.keys(localStorage)
            .filter(key => key.startsWith(prefix))
            .forEach(key => localStorage.removeItem(key));
    } catch {
        // Nothing to clear
    }
}
